import React, { useEffect, useMemo, useState } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AInput from "../../../../views/pages/manage/common/formFeilds/customInput/AInput";
import UploadAttachments from "views/pages/manage/edpOps/stockManagement/stockConsumption/form/MultiUpload.jsx";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { useWizard } from "components/wizard/WizardContext";
import StudentSummaryDetails from "./StudentSummaryDetails";
import Footer from "../Footer";
import { inputHeight } from "../utils";

import {
  createSearchBatchRequest,
  getStudentFromData,
  transferReasonDropdown,
} from "../utils";
import moment from "moment";
import { Input } from "reactstrap";
import { useGetRegularCourseIds } from "views/pages/manage/edpOps/stockManagement/customhooks";
import { CourseDetailsPopupById } from "views/pages/manage/unAssigned/studentCharges/common";
import { AiOutlineEye } from "react-icons/ai";
import useValidateStdOutView from "../../../../hooks/useValidateStdOutView";
import ALoader from "../../../../views/pages/manage/common/a-loader";
const StudentTransferDetails = () => {
  const { updateValues, values, next, dropdowns } = useWizard();
  const {selectedStudent} = values ?? {};
  const dropdown = dropdowns?.data || {};
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const studentForm = {
    ...getStudentFromData(values?.selectedStudent || {}),
  };
  // dependField
  const dependFields = ["businessArea", "academicGroup", "academicCareer"];

  const [transferForm, setTransferForm] = useState({
    supportingDoc: [],
    remarks: "",
  });

  const [courseIdDropdown, courseIdDropdownLoading] =
    useGetRegularCourseIds(transferForm);

  const request = useMemo(
    () => createSearchBatchRequest(transferForm),
    [
      transferForm?.term?.value,
      transferForm?.courseId?.value,
      transferForm?.academicGroup?.value,
      transferForm?.academicCareer?.value,
      transferForm?.businessArea?.value,
    ]
  );
  const isNextButtonDisabled = () => {
    return (
      !transferForm?.transferReason?.value ||
      !transferForm?.courseId?.value ||
      transferForm?.supportingDoc?.length === 0
    );
  };

  const nextStepHandler = () => {
    updateValues("transferDetails", transferForm);
    next();
  };

  const handleChange = (key, value) => {
    setTransferForm((prev) => ({
      ...prev,
      [key]: value,
    }));
    // reset depend filed;
    if (dependFields.includes(key)) {
      handleChange("courseId", null);
    }
    if (key === "businessArea") {
      handleChange("academicCareer", null);
      handleChange("academicGroup", null);
    }
  };

  useEffect(() => {
    setTransferForm({
      ...getStudentFromData(values?.selectedStudent),
      effectiveDate: moment(new Date()).format("DD-MMM-YYYY"),
      ...(values?.transferDetails ? values?.transferDetails : {}),
      supportingDoc: values?.transferDetails?.supportingDoc ?? [],
    });
    setUploadedFiles(values?.transferDetails?.supportingDoc ?? []);
  }, [values?.selectedStudent]);

  const FormGroup = ({ children }) => (
    <div className="form-group col-md-3 mb-2">{children}</div>
  );

  const RenderField = ({
    label,
    field,
    inputKey,
    isDisabled,
    type = "autocomplete",
    icon,
    ...rest
  }) => {
    return (
      <FormGroup>
        {type === "input" ? (
          <AInput
            label={label}
            value={transferForm[inputKey]}
            onChange={(value) => handleChange(inputKey, value)}
            disabled={isDisabled}
            style={inputHeight}
            {...rest}
          />
        ) : type === "date" ? (
          <AInput
            label={label}
            value={moment(transferForm[inputKey]).format("DD-MMM-YYYY")}
            onChange={(value) => handleChange(inputKey, value)}
            disabled={isDisabled}
            style={inputHeight}
            {...rest}
          />
        ) : (
            <AAutoComplete
              label={label}
              currentValue={transferForm[inputKey]}
              items={rest?.options}
              isMulti={false}
              isDisabled={isDisabled}
              handleChange={(value) => handleChange(inputKey, value)}
              height="44px"
              labelStyle={{ color: "#262626" }}
              icon ={icon}
              isLoading={rest?.isLoading}
            />
        )}
      </FormGroup>
    );
  };

  const saveUploadHandler = (files) => {
    setTransferForm((prev) => {
      const updated = { ...prev, supportingDoc: [...files] };
      console.log("Updated transfer form with uploads:", updated);
      return updated;
    });
  };
  console.log(studentForm, "studentForm")

  const { checkingStdOutValidity } = useValidateStdOutView({
    bu: selectedStudent?.businessAreaDispVal,
    psid: selectedStudent?.psid,
    applicationId: selectedStudent?.applicationId
  })

  return (
    <>
      {checkingStdOutValidity && <ALoader position={"fixed"}/>}
      <div className="card p-4">
        <StudentSummaryDetails studentDetails={values?.selectedStudent || {}} />
        <div className="row mb-4 border-bottom pb-3"></div>
        
        <span className="label-color"> Transfer details </span>
        <div className="row">
          <RenderField
            label="Branch*"
            field="branch"
            inputKey="businessArea"
            value={studentForm?.businessArea}
            options={dropdown?.businessAresWithoutSecurity}
          />
          <RenderField
            label="Career*"
            field="career"
            inputKey="academicCareer"
            value={studentForm?.academicCareer}
            options={dropdown?.academicCareer}
          />
          <RenderField
            label="Stream*"
            field="stream"
            inputKey="academicGroup"
            value={studentForm?.academicGroup}
            options={dropdown?.stream}
          />
          <RenderField
            label="Term*"
            field="term"
            inputKey="term"
            value={studentForm?.term}
            options={dropdown?.term}
            isDisabled={true}
          />
          <RenderField
            label="Course ID*"
            field="courseId"
            inputKey="courseId"
            value={studentForm?.courseId}
            options={courseIdDropdown || []}
            isLoading={courseIdDropdownLoading}
            icon={
              <div><CourseDetailsPopupById
               placement = {"right"}
                courseId={transferForm["courseId"]?.value}
                cta={<AiOutlineEye className="ml-2" />}
              />
              </div>
            }
          />

          {/* <RenderField
            label="Batch*"
            field="courseId"
            inputKey="batch"
            value={studentForm?.batch}
            options={batchList || []}
          /> */}
          <RenderField
            label="Reason of transfer*"
            field="reason"
            inputKey="transferReason"
            value={studentForm?.transferReason}
            options={transferReasonDropdown}
          />
          <RenderField
            label="Effective date*"
            field="effectiveDate"
            inputKey="effectiveDate"
            type="date"
            isDisabled={true}
          />
        </div>

        <div className="d-flex flex-column">
          <label className="tiny-semi-bold label-color">
            Remarks (Description)
          </label>
          <Input
            placeholder="Write a comment"
            rows="2"
            type="textarea"
            className="w-50"
            maxLength="255"
            value={transferForm.remarks} // Set the value
            onChange={(e) => handleChange("remarks", e.target.value)} // Update state on change
          />
        </div>

        <div className="form-group col-md-3 mb-2 pl-0 mt-2">
          <label className="tiny-semi-bold label-color">
            Upload documents*
          </label>
          <div>
            <UploadAttachments
              form={transferForm.supportingDoc}
              setFormHandler={saveUploadHandler}
              uploadFileHeader="Upload supporting documents"
              serviceName="STOCK_BRANCH"
              supportedFileTypes={["pdf", "docx", "jpeg", "jpg", "png"]}
              saveCallback={(file, index) => {}}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
            />
          </div>
        </div>
      </div>

      <Footer>
        <div>Transfer details</div>
        <AButton
          disabled={isNextButtonDisabled()}
          onClick={nextStepHandler}
          className="button_remove_left_margin"
          variant="primary_filled"
        >
          Proceed next
        </AButton>
      </Footer>
    </>
  );
};

export default StudentTransferDetails;
